import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToPortfolio = () => {
    document.getElementById('portfolio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-gray-900" data-id="element-71">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-72">
        <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2301&q=80" alt="Modern office environment" className="w-full h-full object-cover opacity-60" data-id="element-73" />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/50 to-gray-900/80" data-id="element-74" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-4xl" data-id="element-75">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6" data-id="element-76">
          Authentische Business- & <br className="hidden md:block" data-id="element-77" />
          <span className="text-[#D4A574]" data-id="element-78">Personal-Branding</span> Fotografie
        </h1>

        <p className="text-lg sm:text-xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-79">
          Moderne Fotos, die Ihr Unternehmen sichtbar machen, Vertrauen stärken
          und neue Kunden gewinnen.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-80">
          <Button size="lg" onClick={scrollToContact} className="w-full sm:w-auto min-w-[200px]" data-id="element-81">
            Jetzt kostenloses Erstgespräch
          </Button>
          <Button variant="outline" size="lg" onClick={scrollToPortfolio} className="w-full sm:w-auto min-w-[200px] border-white text-white hover:bg-white/10 hover:text-white" data-id="element-82">
            Portfolio ansehen
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-83" />
          </Button>
        </div>
      </div>
    </section>;
}